module.exports = __webpack_public_path__ + "img/slide-30.816e5c6a.jpg";